import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { Button } from '@monavate/ui-core';

const Wrapper = styled.div`
    padding: 40px;
    text-align: center;
    display: block;
    font-family: 'Poppins', serif;
`;

const Text404 = styled.div`
    text-align: center;
    font-size: 200px;
    font-style: normal;
    font-weight: 900;
    line-height: 200px; /* 100% */
    letter-spacing: 10px;
    background: linear-gradient(
        112deg,
        #e5fd52 /* TODO: need to change color. There is no such color in themes.ts */ 0.72%,
        #7cead2 /* TODO: need to change color. There is no such color in themes.ts */ 99.28%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

const ErrorTitle = styled.div`
    font-size: 34px;
    font-style: normal;
    font-weight: 600;
    line-height: 44px;
    color: ${(props) => props.theme['Content/primary']}
        /* TODO: check color. Alternatives: ["Content/primary","Content/logo","Content/on-accent"] */;
    margin-top: 15px;
`;

const ErrorText = styled.div`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    color: ${(props) => props.theme['Content/primary']}
        /* TODO: check color. Alternatives: ["Content/primary","Content/logo","Content/on-accent"] */;
    margin-top: 15px;
`;

const Page404 = (): ReactElement => {
    const navigate = useNavigate();
    return (
        <Wrapper>
            <Text404>404</Text404>
            <ErrorTitle>Page does not exist</ErrorTitle>
            <ErrorText>
                The page you are looking for might have been removed,
                <br /> had its name changed or be temporarily unavailable.
            </ErrorText>
            <br />
            <br />
            <Button
                viewType={'primary'}
                handleClick={() => navigate(`/`)}
                dataTestId="button-404-home"
            >
                Return to homepage
            </Button>
        </Wrapper>
    );
};

export default Page404;
